import React from "react"
import ChartistGraph from "react-chartist"
import Chartist from "chartist"
import "chartist-plugin-tooltips"
import "chartist/dist/chartist.min.css"
import "chartist-plugin-tooltips/dist/chartist-plugin-tooltip.css"

export const SalesValueChart = () => {
  const data = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    series: [[1, 2, 2, 3, 3, 4, 3]],
  }

  const options = {
    low: 0,
    showArea: true,
    fullWidth: true,
    axisX: { position: "end", showGrid: true },
    axisY: { showGrid: false, showLabel: false, labelInterpolationFnc: v => `$${v}k` },
    plugins: [Chartist.plugins.tooltip()],  
  }

  return (
    <ChartistGraph
      data={data}
      options={options}
      type="Line"
      className="ct-series-g ct-double-octave"
    />
  )
}

export const SalesValueChartphone = () => {
  const data = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    series: [[1, 2, 2, 3, 3, 4, 3]],
  }

  const options = {
    low: 0,
    showArea: true,
    fullWidth: false,
    axisX: { position: "end", showGrid: true },
    axisY: { showGrid: false, showLabel: false, labelInterpolationFnc: v => `$${v}k` },
    plugins: [Chartist.plugins.tooltip()],          
  }

  return (
    <ChartistGraph
      data={data}
      options={options}
      type="Line"
      className="ct-series-g ct-major-tenth"
    />
  )
}

export const CircleChart = ({ series = [], donutWidth = 20 }) => {
  const sum = (a, b) => a + b
  const total = series.reduce(sum, 0) || 1

  const options = {
    low: 0,
    donutWidth,
    donut: true,
    donutSolid: true,
    fullWidth: false,
    showLabel: false,
    labelInterpolationFnc: v => `${Math.round((v / total) * 100)}%`,
    plugins: [Chartist.plugins.tooltip()],          
  }

  return (
    <ChartistGraph
      data={{ series }}
      options={options}
      type="Pie"
      className="ct-golden-section"
    />
  )
}

export const BarChart = ({ labels = [], series = [], chartClassName = "ct-golden-section" }) => {
  const options = {
    low: 0,
    showArea: true,
    axisX: { position: "end" },
    axisY: { showGrid: false, showLabel: false, offset: 0 },
    plugins: [Chartist.plugins.tooltip()],         
  }

  return (
    <ChartistGraph
      data={{ labels, series }}
      options={options}
      type="Bar"
      className={chartClassName}
    />
  )
}